import { Injectable } from '@angular/core';

const SURVEY_BANNER_DISMISSED_KEY = 'ccomx-survey-banner-dismissed';

@Injectable({
  providedIn: 'root',
})
export class SurveyBannerService {
  isDismissed(): boolean {
    return sessionStorage.getItem(SURVEY_BANNER_DISMISSED_KEY) === 'true';
  }

  dismiss(): void {
    sessionStorage.setItem(SURVEY_BANNER_DISMISSED_KEY, 'true');
  }
}
